<template>
  <div id="acc_detail_right_reservation_unit_select">
    <p class="fw-bolder mb-3">{{ $t('select-an-unit') }}</p>
    <div class="">
      <div class="card radius-1-2 mb-3 border-0 bg-silver" v-for="unit in accommodation.units.filter(u => u.hidden_for_reservation === false)" @click="select(unit)"
           :class="{'selected' : selectedUnit && selectedUnit.id === unit.id}">
        <div class="card-body pt-0 py-md-0 px-0 pe-md-3 ps-md-0 row">
          <div class="col-12 col-md-5 mb-3 mb-md-0 pe-md-2">
            <figure v-if="unit.hasImage(false)" class="aspect-ratio-4-3 mb-0">
              <picture>
                <PartsSrcSetImage :image="unit.getTopImage()" :t_type="'thumbw'" :type="'webp'"/>
                <PartsSrcSetImage :image="unit.getTopImage()" :t_type="'thumbw'" :type="'jpeg'"/>

                <img :src="unit.getTopImage().getTyrionSrc('thumbw')" :alt="unit.getTopImage().title"
                     class="img-cover aspect-ratio-4-3" loading="lazy"
                     :width="unit.getTopImage().seoWidth('thumb')" :height="unit.getTopImage().seoHeight('thumb')">
              </picture>
            </figure>
            <figure class="mb-0 figure-reservation h-100 radius-1-2-top radius-1-2-left-md" v-else>
              <img src="~/assets/img/blank.jpg" :alt="unit.title" class="img-cover h-100 radius-1-2-top radius-1-2-left-md" loading="lazy"
                   width="600" height="337">
            </figure>
          </div>
          <div class="col-12 col-md-7 py-md-2 px-md-2">
            <div class="row px-3 px-md-0">
              <div class="col-12">
                <small class="d-block"><b>{{ unit.title }}&nbsp;{{unit.duplicate_count > 0 ? unit.duplicate_count : ''}}</b></small>
              </div>
              <div class="col-12">
                <small>
                  Max: {{ unit.getTotalNumberOfGuests() }}
                  {{ $t($vysklonujSlovo('host', unit.getTotalNumberOfGuests(), 'ia', 'i')) }}
                </small>
              </div>
              <div class="col-12 mt-2 px-3 text-end">
                <button class="btn btn-sm btn-first btn-rounded" type="button">
                  {{ $t('select') }}
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {useNuxtApp} from "#app";

const props = defineProps(['accommodation', 'selectedUnit']);
const emit = defineEmits(['selectAction']);

const {$vysklonujSlovo} = useNuxtApp();

const select = (item)  =>{
  emit('selectAction', item);
}

</script>
